import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet'
import aphroditeInterface from './aphroditeInterfaceGlobal'
import { css, withStyles } from 'react-with-styles'
import { getPartnershipAndConventionFromUrl } from '../utils'

/* import HypeTheme from './themes/hype'
import YooxTheme from './themes/yoox'
import TimTheme from './themes/tim' */
import PosTheme from './themes/pos'

//const { partnership, convention } = getPartnershipAndConventionFromUrl(location)

/* if (partnership && partnership.toLowerCase().startsWith('pos')) {
  ThemedStyleSheet.registerTheme(PosTheme)
} else if (partnership === 'HYPE' && convention === 'YOOX') {
  ThemedStyleSheet.registerTheme(YooxTheme)
} else if (partnership === 'HYPE4TIM') {
  ThemedStyleSheet.registerTheme(TimTheme)
} else {
  ThemedStyleSheet.registerTheme(HypeTheme)
}
 */
ThemedStyleSheet.registerTheme(PosTheme)

ThemedStyleSheet.registerInterface(aphroditeInterface)

export { css, withStyles }



// WEBPACK FOOTER //
// ./styles/withStyles.js